import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import DesignationChanger from "./NameChanger";

// Image Animation (Appears Immediately)
const imageVariant = {
  hidden: { x: "-40vw", opacity: 0 },
  visible: {
    x: "-5vw",
    opacity: 1,
    transition: { duration: 1.5, ease: "easeOut" },
  },
};

// Text Animation (Only Triggers on Scroll)
const fadeUpVariant = {
  hidden: { y: 50, opacity: 0 },
  visible: (delay) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut", delay },
  }),
};

const LandingSheet = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px -30% 0px" });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);

  return (
    <section
      className="banner-area-two"
      style={{ overflow: "hidden", paddingBottom: isMobile && 50 }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Image Animation (Appears Immediately) */}
          <motion.div
            className="col-xl-6 col-lg-5"
            variants={imageVariant}
            initial="hidden"
            animate="visible" // Image always appears on load
            style={{ overflow: "hidden" }}
          >
            <div className="banner-img-two">
              <img src="/SaiChanduAdapa.png" alt="Profile" />
            </div>
          </motion.div>

          {/* Right Text Animation (Only Appears on Scroll) */}
          <motion.div
            className="col-xl-6 col-lg-7"
            ref={ref}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"} // Only animates when scrolled into view
          >
            <div className="banner-content-two">
              <motion.span
                className="sub-title"
                variants={fadeUpVariant}
                custom={0.2}
              >
                Hi, I am Sai Chandu Adapa
              </motion.span>

              {/* <motion.h2 className="title" variants={fadeUpVariant} custom={0.4}>
                Professional Product <span>Designer</span>
              </motion.h2> */}
              <DesignationChanger />

              {/* Contact Button & Social Icons */}
              <motion.div
                className="banner-content-bottom"
                variants={fadeUpVariant}
                custom={0.6}
              >
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <Link to="/contact" className="btn">
                    Contact Me <span></span>
                  </Link>
                </motion.div>

                <ul className="list-wrap">
                  {Object.entries({
                    "insta.png": "https://www.instagram.com/saichandu_adapa/",
                    "linkedin.png":
                      "https://www.linkedin.com/in/saichandu-adapa-143b41254/",
                    "github.png": "https://github.com/Saichandu03",
                    "arrow.svg": "/resume.pdf",
                  }).map(([key, value], index, array) => (
                    <motion.li
                      key={index}
                      whileHover={{ scale: 1.2 }}
                      transition={{ type: "spring", stiffness: 200 }}
                      variants={fadeUpVariant}
                      custom={0.8 + index * 0.1}
                    >
                      <Link
                        to={value || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={`/${key}`}
                          alt={key}
                          style={
                            index !== array.length - 1
                              ? { height: 35, width: 35 }
                              : {}
                          }
                        />
                      </Link>
                    </motion.li>
                  ))}
                </ul>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Background Animated Shapes */}
      <div className="banner-shape-wrap-two">
        <motion.img
          src="/img/banner/h2_banner_shape01.png"
          alt=""
          className="rotateme"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
        />
        <motion.img
          src="/img/banner/h2_banner_shape02.png"
          alt=""
          className="ribbonRotate"
          animate={{ rotate: -360 }}
          transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
        />
        <motion.img
          src="/img/banner/h2_banner_shape03.png"
          alt=""
          className="ribbonRotate"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
        />
        <img src="/img/banner/h2_banner_shape04.png" alt="" />
      </div>
    </section>
  );
};

export default LandingSheet;
